export function displayDistanceLocale(distanceInMeters: number): string {
  const distanceInFeet = distanceInMeters * 3.28084;
  const roundedDistance = Math.round(distanceInFeet);

  return `${roundedDistance} ft`;
}
